// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-css {
  display: block;
  font-size: 16px;
  font-family: sans-serif;
  font-weight: 700;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.5em;
  appearance: none;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}

.select-css::-ms-expand {
  display: none;
}

.select-css:hover {
  border-color: #888;
}

.select-css:focus {
  border-color: #aaa;
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}

.select-css option {
  font-weight: normal;
}

.react-datepicker {
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.react-datepicker__day--selected {
  background-color: #007bff;
  color: white;
}

.react-datepicker__day--hovered {
  background-color: #f8f9fa;
  color: #007bff;
}

.react-datepicker__day--disabled {
  color: #ccc;
}

.react-datepicker__month-dropdown,
.react-datepicker__year-dropdown {
  color: #007bff;
}

.react-datepicker__calendar-container {
  background-color: #f8f9fa;
}

.strain-name {
  font-size: 18px;
  font-family: Poppins;
  font-weight: 550;
  line-height: 20px;
}

.facility-section {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-around;
}

.facility-box {
  margin: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  flex: 1 1;
  min-width: 200px;
}

.room-diamonds {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.room-diamond {
  margin: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  min-width: 150px;
  text-align: center;
}

.diamond {
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  text-align: center;
}

.diamond-top {
  grid-column: 1 / 3;
}

.diamond-left {
  grid-row: 2;
}

.diamond-right {
  grid-row: 2;
  grid-column: 2;
}

.diamond-bottom {
  grid-column: 1 / 3;
  grid-row: 3;
}

.radar-chart-container {
  width: 300px; /* Set fixed width */
  height: 300px; /* Set fixed height */
  display: flex; /* Use flexbox to center the chart */
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  border: 1px solid #ddd; /* Optional: Add a border around the container */
  background-color: #f9f9f9; /* Optional: Background color for the container */
  border-radius: 8px; /* Optional: Rounded corners */
}

.rooms-section {
  display: flex;
  flex-wrap: wrap; /* Allows items to wrap onto multiple lines */
  gap: 40px; /* Space between items */
  align-items: center; /* Align items vertically in the center */
  justify-content: space-around; /* Align items to the start of the container */
}

@media (max-width: 844px) {
  .filterbar {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }
  .filterbar select {
    min-width: 60px !important;
  }
  .date {
    display: flex;
    width: 100%;
    margin: 0 10px;
  }

  .submit_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2.5rem 1rem 0 0;
  }

  .facility-box {
  }
  .rooms-section {
    width: 80% !important;
  }
  .room-box {
    overflow: scroll !important;
  }
  .radar-chart-container {
    overflow: scroll !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/strains/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,2CAA2C;EAC3C,oBAAoB;EAGpB,gBAAgB;EAChB,sBAAsB;EACtB;wDACsD;EACtD,oCAAoC;EACpC,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,wCAAwC;EACxC,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY,EAAE,oBAAoB;EAClC,aAAa,EAAE,qBAAqB;EACpC,aAAa,EAAE,oCAAoC;EACnD,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,EAAE,sBAAsB;EAC3C,sBAAsB,EAAE,gDAAgD;EACxE,yBAAyB,EAAE,iDAAiD;EAC5E,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA;EACE,aAAa;EACb,eAAe,EAAE,6CAA6C;EAC9D,SAAS,EAAE,wBAAwB;EACnC,mBAAmB,EAAE,yCAAyC;EAC9D,6BAA6B,EAAE,8CAA8C;AAC/E;;AAEA;EACE;IACE,aAAa;IACb,6BAA6B;IAC7B,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;EACA;EACA;IACE,qBAAqB;EACvB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".select-css {\n  display: block;\n  font-size: 16px;\n  font-family: sans-serif;\n  font-weight: 700;\n  color: #444;\n  line-height: 1.3;\n  padding: 0.6em 1.4em 0.5em 0.8em;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  border: 1px solid #aaa;\n  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);\n  border-radius: 0.5em;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\"),\n    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);\n  background-repeat: no-repeat, repeat;\n  background-position: right 0.7em top 50%, 0 0;\n  background-size: 0.65em auto, 100%;\n}\n\n.select-css::-ms-expand {\n  display: none;\n}\n\n.select-css:hover {\n  border-color: #888;\n}\n\n.select-css:focus {\n  border-color: #aaa;\n  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);\n  box-shadow: 0 0 0 3px -moz-mac-focusring;\n  color: #222;\n  outline: none;\n}\n\n.select-css option {\n  font-weight: normal;\n}\n\n.react-datepicker {\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n}\n\n.react-datepicker__day--selected {\n  background-color: #007bff;\n  color: white;\n}\n\n.react-datepicker__day--hovered {\n  background-color: #f8f9fa;\n  color: #007bff;\n}\n\n.react-datepicker__day--disabled {\n  color: #ccc;\n}\n\n.react-datepicker__month-dropdown,\n.react-datepicker__year-dropdown {\n  color: #007bff;\n}\n\n.react-datepicker__calendar-container {\n  background-color: #f8f9fa;\n}\n\n.strain-name {\n  font-size: 18px;\n  font-family: Poppins;\n  font-weight: 550;\n  line-height: 20px;\n}\n\n.facility-section {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n.facility-box {\n  margin: 10px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  flex: 1;\n  min-width: 200px;\n}\n\n.room-diamonds {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.room-diamond {\n  margin: 10px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  min-width: 150px;\n  text-align: center;\n}\n\n.diamond {\n  display: grid;\n  grid-template-rows: 1fr 1fr;\n  grid-template-columns: 1fr 1fr;\n  text-align: center;\n}\n\n.diamond-top {\n  grid-column: 1 / 3;\n}\n\n.diamond-left {\n  grid-row: 2;\n}\n\n.diamond-right {\n  grid-row: 2;\n  grid-column: 2;\n}\n\n.diamond-bottom {\n  grid-column: 1 / 3;\n  grid-row: 3;\n}\n\n.radar-chart-container {\n  width: 300px; /* Set fixed width */\n  height: 300px; /* Set fixed height */\n  display: flex; /* Use flexbox to center the chart */\n  justify-content: center; /* Center horizontally */\n  align-items: center; /* Center vertically */\n  border: 1px solid #ddd; /* Optional: Add a border around the container */\n  background-color: #f9f9f9; /* Optional: Background color for the container */\n  border-radius: 8px; /* Optional: Rounded corners */\n}\n\n.rooms-section {\n  display: flex;\n  flex-wrap: wrap; /* Allows items to wrap onto multiple lines */\n  gap: 40px; /* Space between items */\n  align-items: center; /* Align items vertically in the center */\n  justify-content: space-around; /* Align items to the start of the container */\n}\n\n@media (max-width: 844px) {\n  .filterbar {\n    display: flex;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n  }\n  .filterbar select {\n    min-width: 60px !important;\n  }\n  .date {\n    display: flex;\n    width: 100%;\n    margin: 0 10px;\n  }\n\n  .submit_btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 2.5rem 1rem 0 0;\n  }\n\n  .facility-box {\n  }\n  .rooms-section {\n    width: 80% !important;\n  }\n  .room-box {\n    overflow: scroll !important;\n  }\n  .radar-chart-container {\n    overflow: scroll !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
